import { render, staticRenderFns } from "./WechatSignin.vue?vue&type=template&id=0581520c&"
import script from "./WechatSignin.vue?vue&type=script&lang=js&"
export * from "./WechatSignin.vue?vue&type=script&lang=js&"
import style0 from "./WechatSignin.vue?vue&type=style&index=0&id=0581520c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports